import { render, staticRenderFns } from "./image-display.vue?vue&type=template&id=66fe5e0a&scoped=true&"
import script from "./image-display.vue?vue&type=script&lang=ts&"
export * from "./image-display.vue?vue&type=script&lang=ts&"
import style0 from "./image-display.vue?vue&type=style&index=0&id=66fe5e0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fe5e0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
